import { atom } from 'nanostores';

export class LoadingStore {
  loadingList = new Set();

  $isLoading = atom(false);

  $isInit = atom(false);

  store;

  constructor(store) {
    this.store = store;
  }

  /**
   * @param {string} id
   * @param {'init' | 'default'} behavior
   */
  lock(id, behavior = 'default') {
    this.loadingList.add(id);
    this.$isInit.set(behavior === 'init');
    this.updateState();
  }

  unlock(id) {
    this.loadingList.delete(id);
    this.updateState();
  }

  unlockAll() {
    this.loadingList.clear();
    this.updateState();
  }

  updateState() {
    this.$isLoading.set(this.loadingList.size !== 0);
  }
}
